import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const LOG = () => {
  return (
    <CardSection id="LOG" title="LOG">
      <Paragraph>
        지정한 밑으로 숫자의 로그를 반환합니다. 이 함수는 Excel의 Log 함수와
        동일한 출력을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>LOG(NUMBER, BASE)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 로그를 구하려는 양의 실수입니다.
          </Li>
          <Li>
            <b>BASE</b>는 로그의 밑입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
        {/* <Img src="computeFloor" /> */}
      </ListSection>
    </CardSection>
  );
};
